import Vue from 'vue'
import Vuex from 'vuex'
import Clients from './components/Clients'
import UserType from './components/UserType'
import Inputs from './components/Inputs'
import ProductType from './components/ProductType'
import Product from './components/Product'
import Users from './components/Users'
import Warehouse from './components/Warehouse'
import Outputs from './components/Outputs'
import Kardex from './components/Kardex'
import Helpers from './components/Helpers'
import Suppliers from './components/Suppliers'
import Documents from './components/Documents'
import Operations from './components/Operations'
import Privileges from './components/Privileges'
import Customers from './components/Customers'
import Sales from './components/Sales'
import PaymentMethods from './components/PaymentMethods'
import DocumentTypes from './components/DocumentTypes'
import ToProces from './components/ToProcess'
import Motivos_de_traslado from './components/Motivos_de_traslado'
import Transportista from './components/Transportista'
import Partidas_Contables from './components/PartidasContables'
import Cotizaciones from './components/Cotizaciones'
import Driver from './components/Driver'
import correo_remitente from './components/correo_remitente'
import Movimientos_contables from './components/Movimientos_contables'
import Credenciales from './components/Credenciales'
import Libro_diario from './components/Libro_diario'
import Arreglos from './components/Arreglos'
import Requerimientos from './components/Requerimientos'
import Ordenes_de_compra from './components/Ordenes_de_compra'
import Saldo_inicial from './components/Saldo_inicial'
import Cuentas_por_pagar from './components/Cuentas_por_pagar'
import Documentos from './components/Documentos'

import Trabajadores from './components/Trabajadores'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    Clients,
    UserType,
    Inputs,
    ProductType,
    Product,
    Users,
    Suppliers,
    Warehouse,
    Outputs,
    Kardex,
    Helpers,
    Documents,
    Operations,
    Privileges,
    Customers,
    Sales,
    PaymentMethods,
    DocumentTypes,
    ToProces,
    Motivos_de_traslado,
    Driver,
    Transportista,
    Partidas_Contables,
    Cotizaciones,
    correo_remitente,
    Movimientos_contables,
    Credenciales,
    Libro_diario,
    Arreglos,
    Requerimientos,
    Ordenes_de_compra,
    Saldo_inicial,
    Cuentas_por_pagar,
    Documentos,
    Trabajadores,
  }
})
